// extracted by mini-css-extract-plugin
module.exports = {"flex":"SliderCreneau_flex__2BR-N","error":"SliderCreneau_error__3UOds"};